require('./RASuitabilityTestExpired.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const RASuitabilityTestAnswersInfo = require('../RASuitabilityTestAnswersInfo/RASuitabilityTestAnswersInfo');
const RASuitabilityTestResult = require('../RASuitabilityTestResult/RASuitabilityTestResult');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const {
    SUITABILITY_TEST_URL,
    RA_SUITABILITY_TEST_STATUS,
} = require('../../raConstants/index');
const { MODIFY_SUITABILITY_TEST } = require('constants/flagBasedFeatures');

class RASuitabilityTestExpired extends React.Component {
    constructor(props) {
        super(props);

        this.handleRetakeTestButtonClick = this.handleRetakeTestButtonClick.bind(
            this,
        );
    }

    handleRetakeTestButtonClick() {
        const { buttonRenewClicked, history, setOrigin } = this.props;
        buttonRenewClicked();
        setOrigin(RA_SUITABILITY_TEST_STATUS);
        history.push(SUITABILITY_TEST_URL);
    }

    buildLastTestResult() {
        const {
            date,
            clientRiskProfile,
            clientRiskProfileDescription,
            productDescription,
        } = this.props;
        const lastResultTitle = formatText(
            'raSuitabilityTestValid-lastResultTitle',
        );
        return (
            <div>
                <h2 className="ra-suitability-test-valid__last-result-title">
                    {lastResultTitle}
                </h2>
                <RASuitabilityTestResult
                    date={date}
                    clientRiskProfile={clientRiskProfile}
                    clientRiskProfileDescription={clientRiskProfileDescription}
                    productDescription={productDescription}
                />
            </div>
        );
    }

    buildInfoBox() {
        const { email } = this.props;

        return (
            <ContentBox customClassName="ra-suitability-test-expired__info-content-box">
                <RASuitabilityTestAnswersInfo email={email} />
            </ContentBox>
        );
    }

    buildRenewTestButton() {
        return (
            <React.Fragment>
                <div className="ra-suitability-test-expired__warning-text">
                    <FormattedText value="raSuitabilityTestExpired-raSuitabilityTestExpired_warningText" />
                </div>
                <div className="ra-suitability-test-expired__redo-button">
                    <OKButton onClick={this.handleRetakeTestButtonClick}>
                        <FormattedText value="raSuitabilityTestExpired-raSuitabilityTestExpired_renewTest" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const contentBoxTitle = formatText('raSuitabilityTestExpired-boxTitle');
        const contentBoxMessage = formatText(
            'raSuitabilityTestExpired-raSuitabilityTestExpired_boxContent',
        );
        const lastTestResult = this.buildLastTestResult();
        const infoBox = this.buildInfoBox();
        const buttonRenewTest = immFlagBasedFeatures.get(
            MODIFY_SUITABILITY_TEST,
        )
            ? this.buildRenewTestButton()
            : null;

        return (
            <section className="ra-suitability-test-expired">
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <ContentBox
                                    title={contentBoxTitle}
                                    customClassName="ra-suitability-test-expired__content-box"
                                >
                                    <div className="ra-suitability-test-expired__box-content">
                                        {contentBoxMessage}
                                    </div>
                                    {lastTestResult}
                                    {buttonRenewTest}
                                </ContentBox>
                            </div>
                            <div className="col-xs-12 col-md-4">{infoBox}</div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

RASuitabilityTestExpired.propTypes = {
    buttonRenewClicked: PropTypes.func.isRequired,
    clientRiskProfile: PropTypes.string.isRequired,
    clientRiskProfileDescription: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    date: PropTypes.object.isRequired,
    email: PropTypes.string.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    investorDescription: PropTypes.string.isRequired,
    productDescription: PropTypes.string.isRequired,
    setOrigin: PropTypes.func.isRequired,
};

module.exports = withRouter(RASuitabilityTestExpired);
